﻿(function ($) {
	$.widget('lb.video', {
		options: {
			height: 235,
			width: 426,
			screen: "",
			path: "",
			basepath: "://media.landsbanki.is/vod",
			icons: false,
			autostart: false,
			isHd : false
		},
		_create: function () {
			jwplayer(this.element[0]).setup({
				height: this.options.height,
				width: this.options.width,
				skin: "//assets.l.is/Js/Plugins/jwplayer/v5.8/skins/bekle/bekle.zip",
				provider: "rtmp",
				streamer: "rtmp" + this.options.basepath,
				icons: this.options.icons,
				plugins:{
					hd:{
						file: this.options.path + "_hd.mp4"

					}
				},
				modes: [{
					type: "flash",
					src: "//assets.l.is/Js/Plugins/jwplayer/v5.8/player.swf",
					config: {
						levels: [
								{ bitrate: 600, file: this.options.path + "_low.mp4" },
								{ bitrate: 1200, file: this.options.path + "_hd.mp4" }
							],
						'image': this.options.screen,
						'controlbar': 'over',
						'autostart': this.options.autostart,
						'stretching': 'exactfit'
					}
				}, {
					type: "html5",
					config: {
						'file': "http" + this.options.basepath + this.options.path + "_low.mp4",
						'provider': 'video',
						'icons': 'true'
					}
				},
				{ type: "download"}],
				events: {
					onPlay: function () {
						$("#awesome").find(".slider").awesome("pause");
					},
					onIdle: function () {
						$("#awesome").find(".slider").awesome("play");
					},
					onPause: function () {
						$("#awesome").find(".slider").awesome("play");
					}
				}
			});
		}
	});
})(jQuery);